import { createSlice } from '@reduxjs/toolkit';

import { INITIAL_STATE } from '../state';
import * as eventReducers from './events-reducers';
import * as dialogReducers from './dialog-reducers';

export const scheduleSlice = createSlice({
    name: 'schedule',
    initialState: INITIAL_STATE,
    reducers: {
        ...eventReducers,
        ...dialogReducers
    }
});

export default scheduleSlice.reducer;
export const actions = {
    ...scheduleSlice.actions
}
